// Types
import type { IUser } from '@/types/user'
import ClicableItem from '@/Components/hoc/ClickableItem'
import { Box, Typography, Icon, Tooltip } from '@/CommonComponents'
// Constants
import { COLORS, BRANDING_COLORS, USER_ROLES_COLORS } from '@/lib/constants/colors'
import { hasPermission } from '@/lib/auth/permissions'
import { PERMISSIONS } from '@/lib/constants/permissions'
import { useSession } from '@/contexts/SessionProvider'
interface IUserButtonProps {
  onClick: () => void
}

function consultantTooltip(user: IUser) {
  return (
    <Typography variant="body2">
      You are simulating{' '}
      <Typography variant="body2" sx={{ color: COLORS.SIMULATED_ORG_COLOR }} bold inline>
        {user.simulatedOrganization?.name}
      </Typography>{' '}
      as a{' '}
      <Typography variant="body2" sx={{ color: USER_ROLES_COLORS[user.role] }} bold inline>
        {user.role}
      </Typography>
    </Typography>
  )
}

function nonConsultantTooltip(user: IUser) {
  return (
    <Typography variant="body2">
      Your role is{' '}
      <Typography variant="body2" sx={{ color: USER_ROLES_COLORS[user.role] }} bold inline>
        {user.role}
      </Typography>
    </Typography>
  )
}
export default function UserButton({ onClick }: IUserButtonProps) {
  const { user } = useSession()
  const isSimulatedOrg = user.simulatedOrganization && user.simulatedOrganization.id !== user.organization.id
  const hasTenants = hasPermission({ user, permission: PERMISSIONS.VIEW_TENANTS })
  const typographyStyles = {
    textTransform: 'uppercase',
  }

  return (
    <Tooltip title={hasTenants && user.simulatedOrganization ? consultantTooltip(user) : nonConsultantTooltip(user)}>
      <span>
        <ClicableItem onClick={onClick}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Typography
                variant="subtitle1"
                sx={{ ...typographyStyles, fontWeight: 500, letterSpacing: 0.5, color: COLORS.PRIMARY.DARK }}
              >
                {user.fullName}
              </Typography>
              <Typography
                variant="caption"
                bold
                sx={{
                  ...typographyStyles,
                  color: COLORS.PRIMARY.MAIN,
                }}
              >
                {user.organization.name}
              </Typography>
              {isSimulatedOrg && (
                <Typography
                  variant="caption"
                  sx={{
                    ...typographyStyles,
                    opacity: 0.7,
                    fontSize: '0.75rem',
                    maxWidth: '18ch',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: BRANDING_COLORS.YELLOW.color,
                  }}
                >
                  {`${user.simulatedOrganization?.name}`}
                </Typography>
              )}
            </Box>
            <Icon icon="account-circle" sx={{ fontSize: '2.2rem', opacity: 0.9, color: COLORS.PRIMARY.LIGHT }} />
          </Box>
        </ClicableItem>
      </span>
    </Tooltip>
  )
}
